import React, { useState, useEffect } from 'react';
import { Card, Container, Row, Col, Spinner, Alert, Form } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ChargingBASE_URL } from "../../Config";

const PartnerDashboard = () => {
  const [userId, setUserId] = useState('');
  const [duration, setDuration] = useState('');
  const [salesData, setSalesData] = useState(null);
  const [amountCountData, setAmountCountData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const generateMonthYearOptions = () => {
    const options = [];
    const startMonth = new Date(2024, 6, 1); // July 2024
    const now = new Date();
    let currentMonth = startMonth;

    while (currentMonth <= now) {
      const monthYear = currentMonth.toLocaleString('default', { month: 'long', year: 'numeric' });
      options.push(monthYear);
      currentMonth.setMonth(currentMonth.getMonth() + 1);
    }

    return options;
  };

  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (user) {
      setUserId(user.userId);
    }
  }, []);

  const fetchSalesData = async () => {
    if (!userId || !duration) return;

    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${ChargingBASE_URL}GetsalesMonthlyCount?UserId=${userId}&duration=${encodeURIComponent(duration)}`);
      if (!response.ok) throw new Error('Failed to fetch sales data');
      const data = await response.json();
      setSalesData(data);
    } catch (error) {
      console.error("Sales data error:", error);
      setError("Error fetching sales data.");
    } finally {
      setLoading(false);
    }
  };

  const fetchAmountCountData = async () => {
    if (!userId || !duration) return;

    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${ChargingBASE_URL}GetAmountMonthlyCount?UserId=${userId}&duration=${encodeURIComponent(duration)}`);
      if (!response.ok) throw new Error('Failed to fetch amount count data');
      const data = await response.json();
      setAmountCountData(data);
    } catch (error) {
      console.error("Amount count error:", error);
      setError("Error fetching amount count data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const currentMonth = new Date().toLocaleString('default', { month: 'long', year: 'numeric' });
    setDuration(currentMonth);
  }, []);

  useEffect(() => {
    fetchSalesData();
    fetchAmountCountData();
  }, [userId, duration]);

  return (
    <Container className="py-5">

      <div className="text-center mb-4">
        <Form.Select
          value={duration}
          onChange={(e) => setDuration(e.target.value)}
          style={{ width: '300px', margin: '0 auto' }}
        >
          <option value="">Select Month</option>
          {generateMonthYearOptions().map((option) => (
            <option key={option} value={option}>{option}</option>
          ))}
        </Form.Select>
      </div>

      {error && <Alert variant="danger" className="text-center">{error}</Alert>}

      <Row xs={1} md={2} lg={3} className="g-4">
        {/* Sales Cards */}
        <Col>
          <Card className="text-white bg-success h-100 rounded-4">
            <Card.Body className="text-center">
              <Card.Title>Subscriptions</Card.Title>
              <Card.Text className="display-4">
                {loading ? <Spinner animation="border" size="sm" /> : (salesData?.currentDayRevenue ?? "No Data")}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card className="text-white bg-danger h-100 rounded-4">
            <Card.Body className="text-center">
              <Card.Title>Reversal</Card.Title>
              <Card.Text className="display-4">
                {loading ? <Spinner animation="border" size="sm" /> : (salesData?.currentTotlalReversed ?? "No Data")}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card className="text-white bg-secondary h-100 rounded-4">
            <Card.Body className="text-center">
              <Card.Title>Failed Subscriptions</Card.Title>
              <Card.Text className="display-4">
                {loading ? <Spinner animation="border" size="sm" /> : (salesData?.failed ?? "No Data")}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
        
        {/* Amount Cards */}
        <Col>
          <Card className="text-white bg-success h-100 rounded-4">
            <Card.Body className="text-center">
              <Card.Title>Revenue (PKR)</Card.Title>
              <Card.Text className="display-4">
                {loading ? <Spinner animation="border" size="sm" /> : (amountCountData?.revenue ?? "No Data")}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card className="text-white bg-danger h-100 rounded-4">
            <Card.Body className="text-center">
              <Card.Title>Reversed (PKR)</Card.Title>
              <Card.Text className="display-4">
                {loading ? <Spinner animation="border" size="sm" /> : (amountCountData?.totlalReversedAmount ?? "No Data")}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card className="text-white bg-secondary h-100 rounded-4">
            <Card.Body className="text-center">
              <Card.Title>Total No Balance (Count)</Card.Title>
              <Card.Text className="display-4">
                {loading ? <Spinner animation="border" size="sm" /> : (salesData?.currentDayNoBalance ?? "No Data")}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

      </Row>
    </Container>
  );
};

export default PartnerDashboard;
